import type { createAdminUserBody } from "@nlc/shared-types";

import { zodResolver } from "@hookform/resolvers/zod";
import { adminSchema } from "@nlc/shared-types";
import { useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";

import { Button } from "@/components/button";

import { useCreateAdmin } from "../hooks/useCreateUser";
import { BasicInformation } from "./BasicInformation";
import { CreatingUserOverlay } from "./CreatingUserOverlay";
import { SelectAccounts } from "./SelectAccounts";
import { SelectTimezone } from "./SelectTimezone";

export default function CreateAdmin() {
  const navigate = useNavigate();
  const { isPending, mutate } = useCreateAdmin();
  const {
    control,
    formState: { isValid },
    handleSubmit,
    reset,
  } = useForm<createAdminUserBody>({
    defaultValues: {
      accountIds: [],
      email: "",
      name: "",
      timezoneId: 0,
    },
    mode: "onChange",
    resolver: zodResolver(adminSchema),
  });

  const onSubmit = (data: createAdminUserBody) => {
    mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CreatingUserOverlay isPending={isPending}>
        <BasicInformation
          control={control}
          emailField="email"
          nameField="name"
        />
        <SelectTimezone control={control} timezoneField="timezoneId" />
        <SelectAccounts accountIdsField="accountIds" control={control} />
        <div className="flex justify-end mt-5 pt-xl border-t border-border-secondary">
          <Button
            className="mr-2"
            onPress={() => navigate({ to: "/users" })}
            type="button"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            isDisabled={!isValid || isPending}
            type="submit"
            variant="primary"
          >
            Create user
          </Button>
        </div>
      </CreatingUserOverlay>
    </form>
  );
}
